
import { useContext, useEffect, useState } from 'react';
import CashZoneButton from '../CashZoneButton'
import LoginContext from '../../context'
import axios from 'axios';
import PaginationButtons from '../PaginationButtons';
import { useNavigate, useLocation } from 'react-router-dom';

const MemoTable = () => {
    const { token } = useContext(LoginContext)
    const [tableData, setTableData] = useState([]);
    const [selectedMessages, setSelectedMessages] = useState([]);
    const [loading, setLoading] = useState(false)
    const [expandedRows, setExpandedRows] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 15;
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const intervalId = setInterval(async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/messages/unread-status`, {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token.token}`,
                    }
                });

                const data = await res.json();

                // Redirect if no unread messages AND current path is not "/"
                if (!data.has_unread_messages && location.pathname !== '/') {
                    navigate('/');
                }

            } catch (error) {
                console.error('Error checking unread status:', error);
            }
        }, 30000); // Check every 30 seconds

        return () => clearInterval(intervalId);
    }, [token, location.pathname, navigate]);


    
    const fetchMessages = async () => {
        try {
            // for pagination use this 
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/messages?&page=${currentPage}&size=${pageSize}`, {
                headers: {
                    'Accept': 'application/json',
                    Authorization: `Bearer ${token.token}`,
                }
            });
            //  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/messages`, {
            //     headers: {
            //         'Accept': 'application/json',
            //         Authorization: `Bearer ${token.token}`,
            //     }
            // });
            const data = await response.json();
            setTableData(data.results);
            setTotalPages(data.total_pages);
            // console.log(data)
        } catch (error) {
            console.error('Error fetching messages:', error);
        }
    }
    useEffect(() => {
        fetchMessages();
    }, [currentPage, token]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const toggleRowExpansion = async (id, index) => {
        const isExpanding = !expandedRows.includes(index);
        const message = tableData[index];

        if (isExpanding && !message.is_read) {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/api/users/messages/mark-read`,
                    { message_ids: [id] },
                    {
                        headers: {
                            Authorization: `Bearer ${token.token}`,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        }
                    }
                );
                // Update UI immediately or refetch
                const updatedData = [...tableData];
                updatedData[index].is_read = true;
                setTableData(updatedData);
            } catch (error) {
                console.error('Error marking as read:', error);
            }
        }
        setExpandedRows(prev => {
            if (prev.includes(index)) {
                return prev.filter(i => i !== index);
            } else {
                return [...prev, index];
            }
        });
    };

    const handleCheckboxChange = (id) => {
        setSelectedMessages(prev =>
            prev.includes(id) ? prev.filter(msgId => msgId !== id) : [...prev, id]
        );
    };
    useEffect(() => {
        console.log('Selected messages:', selectedMessages);
    }, [selectedMessages]);

    const handleDelete = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/users/messages/delete`,
                { message_ids: selectedMessages },
                {
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        // 'X-CSRFTOKEN': 'your-token-here' // if needed
                    },
                }
            );
            fetchMessages(); // refresh
        } catch (error) {
            console.error('Delete error:', error);
        }
    };

    const handleMarkRead = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_BASE_URL}/api/users/messages/mark-read`,
                { message_ids: selectedMessages },
                {
                    headers: {
                        Authorization: `Bearer ${token.token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                }
            );
            fetchMessages(); // refresh
        } catch (error) {
            console.error('Mark read error:', error);
        }
    };

    return (
        <>
            <div className='flex flex-col-reverse lg:flex-col gap-[5px] lg:gap-2.5'>
                <table width="100%" cellpadding="0" cellspacing="0" className='font-sans-serif lg:font-Serif text-white'>
                    <colgroup>
                        <col className='w-[10%] lg:w-[5%]' />
                        <col width="" />
                        <col width="20%" />
                        <col width="10%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th align="center" className='font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>선택</strong></th>
                            <th align="center" className='font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>제목</strong></th>
                            <th align="center" className='font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>받은일시</strong></th>
                            <th align="center" className='font-NotoSansKR  h-[35px] lg:h-[33px] text-center font-medium text-xs lg:text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'><strong>상태</strong></th>
                        </tr>
                    </tbody>
                    <tbody>
                        {tableData.map((item, index) => (
                            <>
                                <tr key={index} height="30" className='cursor-pointer'
                                    onClick={() => toggleRowExpansion(item.id, index)}
                                >
                                    <td className='text-center text-xs align-middle h-5 border border-slate lg:border-t-0 lg:border-x-0 lg:border-b lg:border-b-slate'>
                                        <div className="inline-block align-middle lg:hidden me-1">
                                            {/* <input
                                                id={`option${index}`}
                                                type="checkbox"
                                                name="point_type"
                                                value="M"
                                                className="peer hidden"
                                                checked={selectedMessages.includes(item.id)}
                                                onChange={() => handleCheckboxChange(item.id)}
                                            /> */}
                                            <label htmlFor={`option${index}`} className="relative block w-5 h-5 cursor-pointer rounded-md mobile-radio-bg bg-[length:200px_200px] bg-[176px_22px] peer-checked:bg-[-22px_0]" />
                                        </div>
                                        <input
                                            type="checkbox"
                                            name="seq"
                                            id="seq"
                                            value="5543632"
                                            checked={selectedMessages.includes(item.id)}
                                            onChange={() => handleCheckboxChange(item.id)}
                                            className='text-xs text-white align-middle hidden lg:inline-block'
                                            onClick={(e) => e.stopPropagation()}
                                        />
                                    </td>
                                    <td align="center" className='text-center text-xs align-middle h-5 border border-slate lg:border-t-0 lg:border-x-0 lg:border-b lg:border-b-slate'>{item.subject}</td>
                                    <td align="center" className='text-center text-xs align-middle h-5 border border-slate lg:border-t-0 lg:border-x-0 lg:border-b lg:border-b-slate'>{new Date(item.created_at).toISOString().split('T')[0]}</td>
                                    <td className='text-center text-xs align-middle h-5 border border-slate lg:border-t-0 lg:border-x-0 lg:border-b lg:border-b-slate'>
                                        <button
                                            // onClick={() => toggleRowExpansion(index)}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            {item.is_read ? '읽음' : '안읽음'}
                                        </button>
                                    </td>
                                </tr>

                                <tr key={`detail-${index}`} className={` ${expandedRows.includes(index) ? 'table-row' : 'hidden'}`}>
                                    <td colSpan="8" className='text-xs lg:text-center lg:bg-[#3232321a] align-middle h-5 border border-slate lg:border-t-0 lg:border-x-0 lg:border-b lg:border-b-slate p-[5px]' dangerouslySetInnerHTML={{ __html: item.body }} />
                                </tr>
                            </>
                        ))}
                    </tbody>
                </table>
                <div className=''>
                    <CashZoneButton onClick={() => setSelectedMessages(tableData.map(item => item.id))} label="전체선택" link_src="#" active_color="bg-amberGold" active={false} type="button" />
                    <CashZoneButton onClick={handleDelete} label="선택삭제" link_src="#" active_color="bg-[#cc001b]" active={true} type="button" />
                    <CashZoneButton onClick={handleMarkRead} label="선택읽기" link_src="#" active_color="bg-amberGold" active={true} type="button" />
                </div>
            </div>
            <div className='mt-1'>
                <PaginationButtons totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
            </div>
        </>
    )
}

export default MemoTable